import React from 'react'
import { connect } from 'react-redux'
import AdminLayout from '../components/AdminLayout'
import SectionContent from '../components/SectionContent'
import Tests from './Tests'
import ChartCheckCount from './Dashboard/ChartCheckCount'
import ChartCheckSum from './Dashboard/ChartCheckSum'
import SMSStat from './Dashboard/SMSStat'
import CryptoJS from 'crypto-js'
import config from '../config/index'
import OTPStat from './Dashboard/OTPStat'
import CashRegisterStat from './Dashboard/CashRegisterStat'

class Dashboard extends React.Component {
  render() {
    const isFullRoot = CryptoJS.AES.decrypt(!!localStorage.getItem('isFullRoot') ? localStorage.getItem('isFullRoot') : '', config.api.cryptoKey).toString(CryptoJS.enc.Utf8)
    const fullAccess = isFullRoot === '1'

    return (
      <AdminLayout>
        {fullAccess &&
          <React.Fragment>
            <SectionContent>
              <Tests />
            </SectionContent>
            <SectionContent title='Отправленные СМС'>
              <SMSStat />
            </SectionContent>
            <SectionContent title='Отправленные ОТП'>
              <OTPStat />
            </SectionContent>
            <SectionContent title='Количество касс'>
              <CashRegisterStat />
            </SectionContent>
            <SectionContent title='Количество чеков'>
              <ChartCheckCount />
            </SectionContent>
            <SectionContent title=' Сумма чеков'>
              <ChartCheckSum />
            </SectionContent>
          </React.Fragment>
        }
      </AdminLayout>
    )
  }
}

export default connect()(Dashboard)



// WEBPACK FOOTER //
// src/containers/Dashboard.jsx